import {useEffect, useState} from 'react';

export const useWindowHeight = () => {
    const [windowHeight, setWindowHeight] = useState(() =>
        typeof window !== 'undefined' ? window.innerHeight : 0,
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return windowHeight;
};
